export class ResizeElem {
  constructor() {
    this.toggleMenus = {};
  }

  getStyle(e, styleName) {
    var styleValue = "";
    if (document.defaultView && document.defaultView.getComputedStyle) {
      styleValue = document.defaultView.getComputedStyle(e, "").getPropertyValue(styleName);
    } else if (e.currentStyle) {
      styleName = styleName.replace(/\-(\w)/g, function (strMatch, p1) {
        return p1.toUpperCase();
      });
      styleValue = e.currentStyle[styleName];
    }
    return styleValue.replace(/px/g, '');
  }

  setProps(el, props) {
    for (let key in props) {
      el.style.setProperty('--' + key, props[key]);
    }
  };

  init() {
    // 環境
    //this.env = new Env();
    //this.env.detectEnv();
  }

  resizing() {

    let windowLeft = (window.screenLeft || window.screenX || 0);
    let windowTop = (window.screenTop || window.screenY || 0);
    let windowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);
    let windowHeight = (window.innerHeight || document.documentElement.clientHeight || 0);
    let windowScrollY = window.scrollY || window.pageYOffset;
    let windowScrollX = window.scrollX || window.pageXOffset;

    // TOP cover 高さ調整
    // ----------
    if (document.querySelectorAll('.js-resize-index-cover')[0]) {
      //let elem = document.querySelectorAll('.js-resize-index-cover')[0];
      let elems = document.querySelectorAll('.js-resize-index-cover');

      // ツールバーを除いた高さ
      let vh = windowHeight;
      let props = {
        'vh': vh,
      }
      for (let i = 0; i < elems.length; i++) {
        this.setProps(elems[i], props);
      }
      //console.log('resize:' + vh);
    }


    // modal ウインドウの高さ/横幅チェック
    // .js-max-wh-check
    // ----------
    if (document.querySelectorAll('.js-max-wh-check')[0]) {
      let elems = document.querySelectorAll('.js-max-wh-check');

      // ウインドウの高さ/横幅で小さい方
      let minSize = Math.min(windowHeight, windowWidth);

      // コンテンツの幅制限
      let maxSize = Math.round(minSize) * 0.9;
      let props = {
        'width': maxSize,
      }
      for (let i = 0; i < elems.length; i++) {
        this.setProps(elems[i], props);
      }
      //console.log('resize:' + vh);
    }


    // アナウンスメントバーと Header-margin
    if (document.querySelectorAll('.Header-margin')[0]) {
      let elems = document.querySelectorAll('.Header-margin');

      let hh = 0;
      let HeaderElem;
      let noticeElem;
      if (document.querySelectorAll('.Header-inner')[0]){
        HeaderElem = document.querySelector('.Header-inner');
        hh += HeaderElem.clientHeight;
      }
      if (document.querySelectorAll('.Header-notice')[0]){
        noticeElem = document.querySelector('.Header-notice');
        hh += noticeElem.clientHeight;
      }

      hh = Math.round(hh);
      let props = {
        'headerheight': hh,
      }
      for (let i = 0; i < elems.length; i++) {
        this.setProps(elems[i], props);
      }
    }

  }
}